import { Controller } from "@hotwired/stimulus"

// Mirror conditional presence rules without replacing server-side validation.
export default class extends Controller {
  static targets = ["trigger", "field"]

  connect() {
    this.update()
  }

  update() {
    const required = this.triggerTargets.some(field => field.value !== "")
    this.fieldTargets.forEach(field => { field.required = required })
  }
}
